import QuestPage from "./QuestPage";

export default function Trials() {
  return <QuestPage groupKey="trials" />;
}
